module.exports = __webpack_public_path__ + "static/media/013.27c3baed.jpg";